/**
 * @generated SignedSource<<badbb271d21e2d24c225a5546e1305c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tableBody_nativeIssueTable_rankField$data = {
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentType": "tableBody_nativeIssueTable_rankField";
};
export type tableBody_nativeIssueTable_rankField$key = {
  readonly " $data"?: tableBody_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"tableBody_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "tableBody_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "31e9e9126cbced8e8b1316e4a23ca2db";

export default node;
